import { Component } from 'vue-property-decorator'
import Vue from 'vue'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'

@Component
export default class Assignments extends mixins(MixinGame) {
  get turnsTeamA() {
    return Math.floor(this.turnID / 4) + 1
  }

  get turnsTeamB() {
    return Math.floor(this.turnID / 4)
  }

  get breathsPlayer1(): number {
    return this.breaths.playerBreathAmount[0]
  }

  get breathsPlayer2(): number {
    return this.breaths.playerBreathAmount[1]
  }

  get breathsPlayer3(): number {
    return this.breaths.playerBreathAmount[2]
  }

  get breathsPlayer4(): number {
    return this.breaths.playerBreathAmount[3]
  }
}
